import React from "react";

const Text = ({
  name,
  index,
  title,
  validate,
  value,
  change,
  type,
  placeholder,
}) => {
  return (
    <React.Fragment>
      <label
        htmlFor={`${name}-field-${index}`}
        className="block text-sm font-semibold text-red mb-5"
      >
        {title}
        {validate && validate.required ? " *" : ""}
      </label>
      <input
        autoComplete="off"
        autoFocus={index === 0}
        id={`${name}-field-${index}`}
        value={value}
        className="text-input w-full max-w-sm2 border rounded-md border-grey-darker h-18 px-6 md:text-lg text-sm font-medium text-black"
        type={type}
        placeholder={placeholder}
        name={name}
        onChange={(e) => change(index, e.target.value)}
      />
    </React.Fragment>
  );
};

export default Text;
